export default [
  {
    title: "Dashboard",
    icon: "bi bi-columns-gap",
    auth: [0, 1, 2],
    children: [
      {
        title: "Online News",
        route: "dashboard",
        auth: [0, 1, 2],
        icon: "bi bi-newspaper",
        type: "child",
      },
      {
        title: "Social Media",
        route: "dashboard-social-media",
        auth: [0, 1, 2],
        icon: "bi bi-phone",
        type: "child",
      },
    ],
  },
  {
    title: "Online News",
    icon: "bi bi-globe-americas",
    auth: [0, 1, 2],
    children: [
      {
        title: "Fixing",
        route: "fixing",
        auth: [0, 1, 2],
        icon: "bi bi-tools",
      },
      {
        title: "Error",
        route: "error",
        auth: [0, 1, 2],
        icon: "bi bi-x-circle",
        type: "child",
      },
      {
        title: "Missing Class",
        route: "missingclass",
        auth: [0, 1, 2],
        icon: "bi bi-exclamation-circle",
        type: "child",
      },
      {
        title: "Invalid Date",
        route: "invalid-date",
        auth: [0, 1, 2],
        icon: "bi bi-calendar-x",
        type: "child",
      },
      {
        title: "No Article",
        route: "no-article",
        auth: [0, 1, 2],
        icon: "bi bi-file-earmark-x",
        type: "child",
      },
      {
        title: "No Content",
        route: "no-content",
        auth: [0, 1, 2],
        icon: "bi bi-journal-x",
        type: "child",
      },
      {
        title: "No Journalist",
        route: "no-journalist",
        auth: [0, 1, 2],
        icon: "bi bi-person-x",
        type: "child",
      },
      {
        title: "Related Link",
        route: "related-link",
        auth: [0, 1, 2],
        icon: "bi bi-link-45deg",
        type: "child",
      },
      {
        title: "Redirected",
        route: "redirected",
        auth: [0, 1, 2],
        icon: "bi bi-repeat",
        type: "child",
      },
      {
        title: "Unavailable",
        route: "unavailable",
        auth: [0, 1, 2],
        icon: "bi bi-slash-circle",
        type: "child",
      },
      {
        title: "Delay Data",
        route: "delay-data",
        auth: [0, 1, 2],
        icon: "bi bi-clock-history",
        type: "child",
      },
      {
        title: "Scraping Schedule",
        route: "scraping-schedule",
        auth: [0, 1],
        icon: "bi bi-calendar3",
        type: "child",
      },
      {
        title: "Log Scraper Tier 1",
        route: "log-scraper-tier-1",
        auth: [0, 1],
        icon: "bi bi-globe",
        type: "child",
      },
      {
        title: "Log Tier Media",
        route: "log-media-tier",
        auth: [0, 1],
        icon: "bi bi-card-list",
        type: "child",
      },
      {
        title: "EWS Penghentian",
        route: "early-warning-system",
        auth: [0, 1],
        icon: "bi bi-exclamation-circle",
        type: "child",
      },
    ],
  },
  // {
  //   title: "Tiktok",
  //   route: "tiktok-logs",
  //   auth: [0, 1, 2],
  //   icon: "bi bi-tiktok",
  // },
  // {
  //   title: "Facebook",
  //   icon: "bi bi-facebook",
  //   auth: [0, 1, 2],
  //   children: [
  //     {
  //       title: "Logs",
  //       route: "facebook-logs",
  //       auth: [0, 1, 2],
  //       icon: "bi bi-file-earmark-code",
  //       type: "child",
  //     },
  //   ],
  // },







  {
    title: "Forum",
    route: "forum-logs",
    auth: [0, 1, 2],
    icon: "bi bi-chat-text",
  },
  {
    title: "SIPUTRA",
    route: "media-siputra",
    auth: [0, 1, 2],
    icon: "bi bi-clipboard-plus",
  },
  // {
  //   title: "Virtual Machine",
  //   route: "virtual-machine",
  //   auth: [0, 1],
  //   icon: "bi bi-hdd-rack",
  // },

  {
    title: "Master Data",
    icon: "bi bi-gear-wide-connected",
    auth: [0, 1],
    children: [
      {
        title: "Scraper Online News",
        route: "scraper",
        auth: [0, 1],
        icon: "bi bi-card-list",
        type: "child",
      },
      {
        title: "Klasifikasi Masalah",
        route: "problem-classification",
        auth: [0, 1],
        icon: "bi bi-folder",
        type: "child",
      },
      {
        title: "Grafana",
        route: "grafana",
        auth: [0, 1],
        icon: "bi bi-server",
        type: "child",
      },

      {
        title: "Users",
        route: "users",
        auth: [0, 1],
        icon: "bi bi-person-lines-fill",
        type: "child",
      },

      {
        title: "User Sosmed",
        route: "smd-users",
        auth: [0],
        icon: "bi bi-person-badge",
        type: "child",
      },

      {
        title: "WordPress",
        route: "wordpress",
        auth: [0, 1],
        icon: "bi bi-wordpress",
        type: "child",
      },
      
    ],
  },
];
